module.exports = __webpack_public_path__ + "img/page@2x.46b74612.png";